module.exports = __webpack_public_path__ + "static/8e37c2995fa5d7bc16764f13261d4e7bd68a687fdaadff1429180b8d699f6576-b4f751fd389f795f2753dbe61536cbe7.jpeg";